<template lang="pug">
  div#app
    //-
      Preloader
    transition(name="fade")
      Preloader(v-if="preloading")

    //-----------------------
    Navigation
    //-----------------------
    router-view

    //-
      Import Svg icons for general usage
    SVGicons

    //-
      Create the Particles.js Canvas element
    ParticlesJS(v-if="!preloading" v-once)
</template>

<script>
  import Preloader from '@/components/core/Preloader'
  import Navigation from '@/components/core/Navigation'
  //
  import SVGicons from '@/components/SVGicons'
  //
  import dataJson from '@/assets/data.json'
  import { mapGetters } from 'vuex'

  export default {
    name: 'WHOISJORGE',

    data: () => ({
      projectsDatas: dataJson.projects,
      preloading: true
    }),

    components: {
      SVGicons,
      Preloader,
      Navigation
    },

    beforeMount () {
      this.$store.commit('STORE_PROJECTS', this.projectsDatas)
      this.$store.commit('SET_CURRENT_PROJECT', this.projectsDatas[0])
    },

    mounted () {
      this.boot()
    },

    methods: {
      boot () {
        // Disable app visibility
        document.querySelector('main').classList.add('is-disabled')
      },
      beginAnimations () {
        // Enable app visibility
        document.querySelector('main').classList.remove('is-disabled')
      }
    }

  }
</script>



// WEBPACK FOOTER //
// src/App.vue